import { CallbackSideEffect, crudGetMany, CrudGetManyAction, crudGetOne, CrudGetOneAction, crudUpdate, CrudUpdateAction, Identifier, OnFailure, OnSuccess } from "ra-core";

export const crudGetOneEx = (
  resource: string,
  id: Identifier,
  basePath: string,
  handlers?: {
    onSuccess?: OnSuccess,
    onFailure?: OnFailure,
  },
): CrudGetOneAction => {
  const {onSuccess, onFailure} = handlers ?? {}
  const x = crudGetOne(resource, id, basePath)
  delete (x.meta as any)['onFailure']
  if (!onSuccess && !onFailure) { return x }
  const callback: CallbackSideEffect = async ({payload, requestPayload, error}) => {
    if (x.payload === payload) { return } // CRUD_GET_ONE_LOADING
    if (error) {
      if (payload && payload.data && payload.data instanceof Blob) {
        const text = await payload.data.text()
        error = JSON.parse(text)
      }
      onFailure && onFailure(error)
    } else {
      onSuccess && onSuccess(payload)
    }
  }
  return {...x,
    meta: {
      ...x.meta,
      ...({callback}),
    }
  }
};


export const crudGetManyEx = (
  resource: string,
  ids: Identifier[],
  handlers?: {
    onSuccess?: OnSuccess,
    onFailure?: OnFailure,
  },
): CrudGetManyAction => {
  const {onSuccess, onFailure} = handlers ?? {}
  const x = crudGetMany(resource, ids)
  if (!onSuccess && !onFailure) { return x }
  const callback: CallbackSideEffect = ({payload, requestPayload, error}) => {
    if (x.payload === payload) { return } // CRUD_GET_MANY_LOADING
    if (error) {
      onFailure && onFailure(error)
    } else {
      onSuccess && onSuccess(payload)
    }
  }
  return {...x,
    meta: {
      ...x.meta,
      ...({callback}),
    }
  }
}


export const crudUpdateEx = (
  resource: string,
  id: Identifier,
  data: any,
  previousData: any,
  handlers?: {
    onSuccess?: OnSuccess,
    onFailure?: OnFailure,
  },
): CrudUpdateAction => {
  const {onSuccess, onFailure} = handlers ?? {}
  const x = crudUpdate(resource, id, data, previousData, '')
  x.meta.onSuccess && delete (x.meta as any).onSuccess;
  x.meta.onFailure && delete (x.meta as any).onFailure;
  const callback: CallbackSideEffect = ({payload, requestPayload, error}) => {
    if (x.payload === payload) { return } // CRUD_GET_ONE_LOADING
    if (error) {
      onFailure && onFailure(error)
    } else {
      onSuccess && onSuccess(payload)
    }
  }
  return {...x,
    meta: {
      ...x.meta,
      ...({callback}),
    }
  }
}


